module.exports = __webpack_public_path__ + "media/images/Cup-and-Candle-1920px-2-e43a25a87c431c8697437476aad0efa6.png";